import Vue from "vue";
import Vuex from "vuex";

import TBSLImg from "@/assets/img/tn/tbsl-tn.jpg";
import OTEImg from "@/assets/img/tn/on-the-edge_tn.jpg";
import JaruImg from "@/assets/img/tn/jaru-nz.jpg";
import EgauImg from "@/assets/img/tn/egau_tn.jpg";
import EgauGif from "@/assets/gif/tn/EGAU-gif.gif";
/* import RefBeJuSoImg from "@/assets/img/tn/tn_refbejuso.jpg";
 *//* import HochzeitTAImg from "@/assets/img/tn/hochzeit_ta_tn.jpg";
 */import FeetPealsImg from "@/assets/img/tn/feetpeals-regarder.jpg";
/* import KitaVisavieImg from "@/assets/img/tn/kita-visavie.jpg"; */
/**import HyundaiImg from "@/assets/img/tn/hyundai_tn.jpg";**/
import NilsImg from "@/assets/img/tn/NilsBuri-thumbnail.jpg";
import reWoodImg from "@/assets/img/tn/reWood-thumbnail.jpg";
import NoFearImg from "@/assets/img/tn/no-fear_thumbnail.jpg";
/**import QuarantineImg from "@/assets/img/tn/Quarantine-Pizza-thumbnail.jpg";**/
import BlasercafeImg from "@/assets/img/tn/blasercafe-thumbnail.jpg";
/* import DWImg from "@/assets/img/tn/digital-world-thumbnail.jpg";
import PhotoshootImg from "@/assets/img/tn/photoshoot_ocular_tn.jpg"; */
import EmanuelWuethrichImg from "@/assets/img/tn/emanuel_wuethrich_tn.jpg";
/* import AppsTeamImg from "@/assets/img/tn/appsteam-tn.jpg"; */
import FrisaeImg from "@/assets/img/tn/frise-tn.jpg";
import ChempaeImg from "@/assets/img/tn/chempae-tn.jpg";
import SdImg from "@/assets/img/tn/sd-tn.jpg";

import AndrinPortrait from "@/assets/img/team/andrin_portrait_ocular.jpg";
import CedricPortrait from "@/assets/img/team/cedric_portrait_ocular.jpg";
import JonasPortrait from "@/assets/img/team/jonas_portrait_ocular.jpg";
import AndrinVid from "@/assets/vid/team/Andrin.mp4";
import CedricVid from "@/assets/vid/team/Cedric.mp4";
import JonasVid from "@/assets/vid/team/Jouns.mp4";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    projects: [
      {
        tag: "Musikvideo",
        image: SdImg,
        title: `LocY - "Slow Down!"`,
        path: "slow-down",
        video: "https://www.youtube.com/embed/3oSUMN9nUDw?si=RfJ1EZeli6LTkvWQ",
        description: `The official music video of  "Slow Down!" a song by LocY`,
        rolls: [
          { title: "Director & Schnitt", name: "Jonas Kunz" },
          { title: "Co-Director:", name: "LocY & Minako Bisang" },
          { title: "DoP & Colorist:", name: "Andrin Schranz<br><br>" },
          { title: "1st AC:", name: "Noel Gygax" },
          { title: "Animation:", name: "Minako Bisang & Ysabel Steiner" },
          { title: "Makeup:", name: "Sarah Walker" },
          { title: "PAs:", name: "Feride Saljmanaj, Jasmin Angelina & Minako Bisang" },
          { title: "Styling:", name: "Reya Amalia <br><br>" },
          { title: "Music written by:", name: "LocY" },
          { title: "Music produced by:", name: "LocY & Edu Galera" },
          { title: "Recorded at:", name: "Mu.sick Studios <br><br>" },
          { title: "Behind the Scenes:", name: "Daniel Lucio" },
        ]
      },
      {
        tag: "Dokumentation",
        image: TBSLImg,
        title: 'The Bittersweet Life',
        path: "the-bittersweet-life",
        video: "https://www.youtube.com/embed/MM9XUcJ1hBw",
        description:
          "Ara lebt seit ihrer Geburt in Seoul, Südkorea. In der Dokumentation «The Bittersweet Life» erzählt sie von ihrem Leben in der grössten Stadt Südkoreas. Das Leben in der Metropole bietet viele Chancen und Möglichkeiten, hat aber auch seine Schattenseiten. Ara spricht offen über ihr privates Leben, ihre Schwierigkeiten und wie sie das Leben in der Grossstadt meistert.",
        rolls: [
          { title: "Starring", name: "Ara Ko<br><br>" },
          { title: "Director & Interview", name: "Jonas Kunz" },
          { title: "Cinematography", name: "Andrin Schranz & Cedric Ribi" },
          { title: "Production Assistance", name: "Aishvina Pavanandan & Feride Seljmanaj<br><br>" },
          { title: "Lead Editor", name: "Cedric Ribi" },
          { title: "Story Direction", name: "Ocular Collective" },
          { title: "Colorist & Animator", name: "Andrin Schranz" },
          { title: "Audio & Sound Design", name: "Jonas Kunz<br><br>" },
          { title: "Special Thanks", name: "Jean-Pierre Bonny <br><br> Feride Seljmanaj <br>Aishvina Pavanandan<br><br>Dan Rodriguez<br>Jamin Volkart<br>Jasmin Koç<br>Leona Schranz<br>Luka Aeschlimann<br>Manuel Maurer<br>Maurice Busch<br>Pascal Ribi<br>Sascha Kobler" },


        ]
      },
      {
        tag: "Kurzfilm",
        image: ChempaeImg,
        title: 'CHEMPÄ.',
        path: 'chempae',
        video: "https://www.youtube.com/embed/rdOYQB_9wZ4",
        rolls: [
          { title: "Starring", name: "Jonas Kunz <br><br>" },
          { title: "Story by", name: "Ocular Collective" },
          { title: "Director", name: "Jonas Kunz" },
          { title: "Cinematographer", name: "Andrin Schranz & Cedric Ribi" },
          { title: "PA", name: "Luka Aeschlimann <br><br>" },
          { title: "Edit & Colorgrading", name: "Jonas Kunz" },
        ]
      },
      {
        tag: "Kurzfilm",
        image: FrisaeImg,
        title: 'FRISÄ',
        path: "frisae",
        video: "https://www.youtube.com/embed/T3vn5nujkn8",
        rolls: [
          { title: "Starring", name: "Luka Aeschlimann <br><br>" },
          { title: "Directed by", name: "Ocular Collective" },
          { title: "Cinematographer", name: "Andrin Schranz & Cedric Ribi" },
          { title: "PA", name: "Jonas Kunz<br><br>" },
          { title: "Editor", name: "Andrin Schranz" },



        ]
      },
      {
        tag: "Musikvideo",
        image: EgauImg,
        gif: EgauGif,
        title: 'Jule X - EGAU',
        path: "egau",
        video: "https://www.youtube.com/embed/EE4Mr78Wh-E",
        rolls: [
          { title: "Director & Editor", name: "Jonas Kunz" },
          { title: "Dir. of Photography", name: "Andrin Schranz" },
          { title: "AC", name: "Cedric Ribi" }
        ]
      },
      {
        tag: "Kurzfilm",
        image: OTEImg,
        title: 'on the edge',
        path: "on-the-edge",
        video: "https://www.youtube.com/embed/704tnqgyY6k",
        rolls: [
          { title: "A film by", name: "Cedric Ribi" }
        ]
      },
      {
        tag: "Musikvideo",
        image: JaruImg,
        title: 'Jaru - NÜT ZTÜE',
        path: "jaru-nz",
        video: "https://www.youtube.com/embed/a3eobSkWqfo",
        rolls: [
          { title: "Director & Editor", name: "Jonas Kunz" },
          { title: "Cinematographer", name: "Andrin Schranz" },
          { title: "Set support", name: "Luis Schneuwly" }
        ]
      },
      {
        tag: "Dokumentation",
        image: NilsImg,
        title: "Nils Buri",
        path: "nils-buri",
        video: "https://www.youtube.com/embed/URoZHHvk4NQ",
        description:
          "Nils Buri ist Rugbyspieler. Er spielt in der ersten Mannschaft von Bern und in der U20 der Schweizer Nationalmannschaft. Diese Mini-Dokumentation behandelt seine bisherige Karriere, aber auch seine Träume für die Zukunft. Die Dokumentation gibt Eindrücke in seine Kindheit und wie er zum Rugby spielen gekommen ist. Er erzählt von seinen Erlebnissen und wie er seine Ziele erreichen möchte.",
        rolls: [
          { title: "Edited by", name: "Cedric Ribi, Jonas Kunz" },
          { title: "Sound Design by", name: "Jonas Kunz" },
          { title: "Colors by", name: "Andrin Schranz" }
        ]
      },
      {
        tag: "Imagefilm",
        image: reWoodImg,
        title: "reWood",
        path: "rewood",
        video: "https://www.youtube.com/embed/mgHAAqsJNEE",
        description:
          "ReWood gibt altem Holz ein zweites Leben. Aus altem Holz werden stylische und nachhaltige Möbel produziert. Die Produkte werden komplett in der Schweiz, in einer kleinen Werkstadt im Herzen von Biel von gelernten Schreinern hergestellt. Dieser Imagefilm zeigt die Produktion, in ihrer Werkstatt, bis zum fertigen Möbel. <br><br>Mehr zu ReWood findest du unter <a target='_blank' href='https://rewood.ch/'>rewood.ch</a>",
        rolls: [
          { title: "Edited by", name: "Cedric Ribi, Jonas Kunz" },
          { title: "Sound Design by", name: "Jonas Kunz" },
          { title: "Colors by", name: "Andrin Schranz" }
        ]
      },
      /*  {
         tag: "Imagefilm",
         image: KitaVisavieImg,
         title: "Kita VISAVIE",
         path: "kita-visavie",
         video: "https://www.youtube.com/embed/qWLXg0Z6IqU",
         description:
           "Um die Werte und Entstehung der Kita VISAVIE visuell zu verpacken, setzten wir für sie diesen Imagefilm um.<br><br> Mehr zur Kita VISAVIE findest du unter <a target='_blank' href='https://www.kitavisavie.ch/'>kitavisavie.ch</a>",
         rolls: [
           { title: "Edited by", name: "Andrin Schranz" },
           { title: "Camera by", name: "Cedric Ribi, Jonas Kunz" }
         ]
       }, */
      {
        tag: "Kurzfilm",
        image: NoFearImg,
        title: "No Fear",
        path: "no-fear",
        video: "https://www.youtube.com/embed/u45Iv_RBD00",
        rolls: [
          { title: "A film by", name: "Andrin Schranz" },
        ]
      },
      /*       {
              tag: "Hochzeitsfilm",
              image: HochzeitTAImg,
              title: "Hochzeit T+A",
              path: "hochzeit-ta",
              video: "https://www.youtube.com/embed/d_6NA6oGZds",
              rolls: [
                { title: "Shot & Edited by", name: "Andrin Schranz" }
              ]
            }, */
      {
        tag: "Musikvideo",
        image: FeetPealsImg,
        title: 'feetpeals - "regarder en avant"',
        path: "feetpeals-regarder",
        video: "https://www.youtube.com/embed/BvCGypx7kDs",
        rolls: [
          { title: "Directed by", name: "Amelia" },
          { title: "Edited by", name: "Jonas Kunz" },
          { title: "Camera by", name: "Cedric Ribi, Jonas Kunz" }
        ]
      },
      {
        tag: "Dokumentation",
        image: EmanuelWuethrichImg,
        title: "Emanuel Wuethrich",
        path: "emanuel-wuethrich",
        video: "https://www.youtube.com/embed/O6Ytucx0G94",
        description:
          "In dieser kurzen Dokumentation geht es um den 17-Jährigen Rennfahrradfahrer Emanuel Wüthrich von Biel. Er gibt uns ein Einblick in sein Leben und erzählt von der Schwierigkeit den Rennsport und sein Privatleben unter einen Hut zu bringen. Emanuel zeigt wie das Fahrradfahren zu seinem Hobby wurde und daraus dann eine Leidenschaft entstand.<br><br>Wir (Jonas und Andrin) haben uns im April 2019 dazu entschieden uns zum ersten Mal einer Dokumentation zu widmen. Nach kurzer Zeit wenden wir uns auch schon an Emanuel, ob er Lust hätte, dass wir eine Dokumentation über ihn machen würden. Er war direkt dabei! Also haben wir mit der Planung und parallel mit der Produktion begonnen.<br><br>Im Mai 2019 waren wir beim Zeitrennen in Thun, Amsoldingen dabei und ein Monat später bereits bei der Schweizer Meisterschaft in Fischingen,Thurgau. Das waren wahrscheinlich die zwei strengsten Film Termine, dass man auch alles im Kasten hat. Zum Abschluss des Projekts brauchten wir noch ein Interview, welches wir bei ihm zuhause nahe beim Bielersee drehten. Die meiste Zeit haben wir schlussendlich in die Nachbearbeitung der Dokumentation gesteckt.<br><br>Am 11. Oktober 2019 veröffentlichten wir dann endlich den Kurzdokumentarfilm, in welchen wir über einen Zeitraum von einem halben Jahr investiert haben.<br><br>Danke auch an das Bielertagblatt, welches ein Artikel über unser Projekt veröffentlicht hat. Und auch ein riesen Danke an Cedric Ribi, Benjamin Bolli und Mischa Miller bei der Realisierung dieses Projektes.",
        rolls: [
          { title: "Directed by", name: "Jonas Kunz, Andrin Schranz" },
          { title: "Colors by", name: "Andrin Schranz" },
          { title: "Sound Design by", name: "Jonas Kunz" }
        ]
      },
      /*       {
              tag: "Eventfilm",
              image: RefBeJuSoImg,
              title: "Lange Nacht der Kirchen",
              path: "lange-nacht-der-kirchen_eventfilm",
              video: "https://www.youtube.com/embed/EKYsrmM8qv4",
              rolls: [
                { title: "Camera", name: "Jonas Kunz, Cedric Ribi, Andrin Schranz" },
                { title: "Edit & Colors", name: "Andrin Schranz" },
              ]
            }, */
      /*       {
              tag: "Imagefilm",
              image: AppsTeamImg,
              title: "Apps Team",
              path: "appsteam",
              video: "https://www.youtube-nocookie.com/embed/R-tLM7Ak9PQ",
              description:
                "Zum start neuer Lernenden im Swisscom Appsteam, erstellten wir im Rahmen unserer Lehre diese kleine Video für das Apps Team:<br><br> <i>9 Lernende im ersten Jahr begannen ihren ersten Arbeitstag im Apps-Team. In den nächsten Wochen werden sie unter der Aufsicht von Fachleuten und Tutoren des Apps-Teams das Programmieren und Gestalten erlernen. Wenn sie fertig sind, werden sie mit unseren Fachleuten bereit sein, Sie mit fantastischen Software und Designs zu erfreuen.</i>",
              rolls: [
                { title: "Camera by", name: "Andrin Schranz, Jonas Kunz" },
                { title: "Edited by", name: "Andrin Schranz, Jonas Kunz" },
                { title: "Sound Design by", name: "Jonas Kunz" },
                { title: "Colors by", name: "Andrin Schranz" }
              ]
            }, */
      /**{
        tag: "Sonstige",
        image: QuarantineImg,
        title: "Quarantine",
        path: "quarantine-pizza",
        video: "https://www.youtube.com/embed/aHXJNl6TTyY",
        description:
          "Da wir auf Grund der momentanen Lage mit dem Coronavirus leider keine Aufträge annehmen oder sonstige Videos drehen können, entschlossen wir uns, ein 100% Home-made Video zu realisieren. Die Idee hatten wir schnell und so setzen wir uns auch gleich an die Realisierung. Andrin nahm die Aufnahmen auf und sendete diese zu Cedric. Er erstellte den Rohschnitt. Danach teilte er den Rohschnitt mit Andrin und Jonas. Jonas arbeitete das Sounddesign aus. Die Color-Correction und das Color-Grading wurde von Andrin gemacht. Währenddessen perfektionierten wir den Schnitt noch und fertig war das Endprodukt.",
        rolls: [
          { title: "Camera by", name: "Jano Schranz" },
          { title: "Edited by", name: "Cedric Ribi" },
          { title: "Sound Design by", name: "Jonas Kunz" },
          { title: "Colors by", name: "Andrin Schranz" }
        ]
      },**/
      {
        tag: "Imagefilm",
        image: BlasercafeImg,
        title: "Blasercafé",
        path: "blasercafe",
        video: "https://www.youtube.com/embed/62I9RK24tpY",
        description:
          'Dieser Imagefilm über das international bekannte Unternehmen Blasercafé, wurde produziert, um das Unternehmen in einem kurzen Video besser für die Kunden vorzustellen. Auch das dazugehörige, nebenan gelegene Kaffee "Rösterei", wurde im Film aufgegriffen. Mit diesem Film wollten wir die Liebe zum Kaffee von Blasercafé darstellen. Durch die freundlichen und offenen Mitarbeiter konnten wir verschiedenste Aufnahmen erstellen und das Unternehmen umfänglich darstellen. Im Film wurden die Schritte von der rohen Kaffeebohne bis zum fertigen Kaffee gezeigt. Der Imagefilm entstand im Rahmen eines "ÜK", welcher Teil der Lehre zum Mediamatiker ist. Vielen Dank an Murielle Wyttenbach für die organisatorische Unterstützung.',
        rolls: [
          { title: "Edited by", name: "Cedric Ribi, Andrin Schranz" },
          { title: "Sound Design by", name: "Jonas Kunz" },
          { title: "Colors by", name: "Andrin Schranz" }
        ]
      },
      /**{
        tag: "Werbefilm",
        image: HyundaiImg,
        title: "Hyundai",
        path: "hyundai",
        video: "https://www.youtube.com/embed/M55XmUKwlbU",
        description:
          "Diese Werbung soll ein Auto der Marke Hyundai bewerben und dessen Vorteile zeigen. Das Video steht nicht in Kooperation mit Hyundai und ist keine offizielle Werbung. Vielen Dank an alle die bei der Umsetzung dieses Projekts mitgeholfen haben.",
        rolls: [
          { title: "Edited by", name: "Jonas Kunz, Andrin Schranz" },
          { title: "Camera by", name: "Cedric Ribi, Andrin Schranz" },
          { title: "Colors by", name: "Andrin Schranz" }
        ]
      },**/
      /*       {
              tag: "Kurzfilm",
              image: DWImg,
              title: "Digital World",
              path: "digital-world",
              video: "https://www.youtube.com/embed/KRd5QBvMb_8",
              description:
                "Für dieses Video haben wir beschlossen, uns vor eine kleinere Herausforderung zu stellen. Erstens wollten wir ein Video, welches etwas aussagt, produzieren und zweitens filmten wir das ganze Video auf unseren analogen Objektiven die zwischen 20 & 40 Jahre alt sind. Als wir die Story und das Material bereit hatten, gingen wir einen Tag in der schönen Altstadt von Thun filmen. Das Handling der Objektive war nicht ganz einfach. Dazu wollten wir auf Stabilisationsmittel für die Kamera verzichten und filmten alles aus der Hand. Trotzdem hatten wir am Ende des Tages tolle Aufnahmen.",
              rolls: [
                { title: "Actor", name: "Pascal Ribi" },
                { title: "Camera by", name: "Cedric Ribi" },
                { title: "Edited by", name: "Jonas Kunz" },
                { title: "Colors by", name: "Andrin Schranz" }
              ]
            }, */
      /*  {
         tag: "Sonstige",
         image: PhotoshootImg,
         title: "Photoshoot Ocular",
         path: "photoshoot-ocular",
         video: "https://www.youtube.com/embed/KqSEG-iplXQ",
         description:
           "An einem verregneten Sonntag raus gehen? Wir haben uns gedacht, das wäre ein perfekter Zeitpunkt durch die Schweiz zu reisen und Fotos zu machen. Das Ganze haben wir in diesem kurzen Video zusammengefasst. Am Sonntagmorgen trafen wir uns alle in Zürich und gingen zu einem Parkhaus gleich beim Prime Tower. Das es nicht langweilig wurde ging die Reise nach einer kurzen zwischen Verpflegung am Zürich HBF weiter nach Luzern. Dort entschieden wir, so spontan wie wir sind, auf ein Boot zu gehen und gleich wieder auszusteigen um den Sonnenuntergang zu geniessen. Im Dunkeln kamen wir dann wieder in Luzern an und hielten das Nachtleben in einigen Bildern fest.",
         rolls: [
           { title: "Edited by", name: "Cedric Ribi, Jonas Kunz" },
           { title: "Colors by", name: "Andrin Schranz" },
           { title: "Sound Design by", name: "Jonas Kunz" }
         ]
       }, */
    ],
    customers: [
      "blasercafe.svg",
      "refbejuso.png",
      "B&H.png",
      "casalini.svg",
      "kitavisavie.png",
      "rewood.svg",
      "atelier.png",
      "feetpeals.png",
    ],
    galleries: [
      {
        title: "events",
        images: [
          "hochzeit_paarfoto_ocular",
          "paarfoto_antrag_ocular",
          "hochzeit_zeremonie_ocular",
          "paarfoto_regenschirm-jump_ocular",
          "hochzeit_paarfoto-auto_ocular",
          "paarfoto_ocular",
          "hochzeit_rede_ocular",
          "paarfoto_regenschirm_ocular",
          "hochzeit_kuss_ocular",
          "paarfoto_kuss_ocular",
          "hochzeit_tanz_ocular",
          "paarfoto_regenschirm-kuss_ocular"
        ]
      },
      {
        title: "corporate",
        images: [
          "kita_1_ocular",
          "kita_2_ocular",
          "kita_3_ocular",
          "kita_4_ocular",
          "kita_5_ocular",
          "kita_6_ocular",
          "schreiner_ocular",
          "spengler_1_ocular",
          "spengler_2_ocular",
          "spengler_3_ocular"
        ]
      },
      {
        title: "portrait",
        images: [
          "cyril_ocular",
          "timon_ocular",
          "kim_ocular",
          "leona_6_ocular",
          "leona_8_ocular",
          "leona_9_ocular",
          "mahe_1_ocular",
          "mahe_2_ocular",
          "mahe_3_ocular",
          "francois_1_ocular",
          "francois_2_ocular",
          "francois_3_ocular",
          "leona_1_ocular",
          "leona_2_ocular",
          "leona_3_ocular",
          "leona_4_ocular",
          "leona_5_ocular",
          "debi_parkhaus_ocular-2",
          "emporia_bern_ocular-2",
          "laura_bern_ocular",
          "pascal_thun_ocular-2"
        ]
      }
    ],
    team: [
      {
        name: "Andrin",
        mail: "andrin@ocular.ch",
        img: AndrinPortrait,
        vid: AndrinVid
      },
      {
        name: "Cedric",
        mail: "cedric@ocular.ch",
        img: CedricPortrait,
        vid: CedricVid
      },
      {
        name: "Jonas",
        mail: "jonas@ocular.ch",
        img: JonasPortrait,
        vid: JonasVid
      }
    ],

    imprint: [
      {
        title: "Inhaltliche Verantwortung",
        content:
          '<strong>ocular KLG</strong><br>Kirchlindachstrasse 15<br>3052 Zollikofen<br><br><a href="mailto:info@ocular.ch">info@ocular.ch</a><br><br>CHE-411.013.552'
      },
      {
        title: "Disclaimer",
        content:
          "Alle Texte und Links wurden sorgfältig geprüft und werden laufend aktualisiert. Wir sind bemüht, richtige und vollständige Informationen auf dieser Website bereitzustellen, übernehmen aber keinerlei Verantwortung, Garantien oder Haftung dafür, dass die durch diese Website bereitgestellten Informationen, richtig, vollständig oder aktuell sind. Wir behalten uns das Recht vor, jederzeit und ohne Vorankündigung die Informationen auf dieser Website zu ändern und verpflichten uns auch nicht, die enthaltenen Informationen zu aktualisieren. Alle Links zu externen Anbietern wurden zum Zeitpunkt ihrer Aufnahme auf ihre Richtigkeit überprüft, dennoch haften wir nicht für Inhalte und Verfügbarkeit von Websites, die mittels Hyperlinks zu erreichen sind. Für illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für Schäden, die durch Inhalte verknüpfter Seiten entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde. Dabei ist es gleichgültig, ob der Schaden direkter, indirekter oder finanzieller Natur ist oder ein sonstiger Schaden vorliegt, der sich aus Datenverlust, Nutzungsausfall oder anderen Gründen aller Art ergeben könnte.",
        subSections: [
          {
            title: "Copyright",
            content:
              "Die Urheber- und alle anderen Rechte an Inhalten wie Bilder, Illustrationen, Videos wie auch Texte oder andere Inhalte auf dieser Website, gehören ausschliesslich der Firma ocular KLG oder den speziell genannten Rechteinhabern. Für die Verwendung jeglicher Inhalte ist unsere schriftliche Zustimmung im Voraus einzuholen."
          }
        ]
      },
      {
        title: "Datenschutz",
        content:
          "Für die Sicherheit der Datenübertragung im Internet können wir keine Gewähr übernehmen, insbesondere besteht bei der Übertragung von Daten per E-Mail die Gefahr des Zugriffs durch Dritte.<br>Einer Nutzung der im Impressum veröffentlichten Kontaktdaten durch Dritte zu Werbezwecken wird hiermit ausdrücklich widersprochen. Der Betreiber behält sich für den Fall unverlangt zugesandter Werbe- oder Informationsmaterialien ausdrücklich rechtliche Schritte vor.<br>Sollten einzelne Regelungen oder Formulierungen dieses Haftungsausschlusses unwirksam sein oder werden, bleiben die übrigen Regelungen in ihrem Inhalt und ihrer Gültigkeit hiervon unberührt.",
        subSections: [
          {
            title: "Cookies",
            content:
              'Unsere Website verwendet Cookies um dir bestmögliche Funktionalität bieten zu können. Cookies sind kleine Textdateien, welche auf deinem Gerät gespeichert werden um sich Entscheidungen von dir zu merken, Benutzer bezogene Informationen zu speichern, die Benutzerfreundlichkeit zu steigern und die volle Funktionalität unserer Website zu ermöglichen.<br><br><i>Bsp. : Wenn du bei unseren Cookie-Einstellungen die Cookie-Bedingungen akzeptierst oder ablehnst wird ein Cookie mit deiner Entscheidung gespeichert, sodass du dies nicht bei jedem Besuch auf unserer Website tun musst.</i><br><br>Im Falle, dass du unsere Cookie-Bedingungen ablehnst wirst du bemerken, dass du unsere <a href="/filme">Filmprojekte</a> nicht mehr anschauen kannst. Das liegt daran, dass beim einbinden unserer Videos von YouTube, Cookies geladen werden und Google so Benutzer bezogene Daten speichert. Mehr Informationen zu YouTube findest du im nächsten Abschnitt <a href="#YouTube">YouTube.</a>'
          },
          {
            title: "YouTube",
            content:
              'Unsere Website nutzt Plugins der von Google betriebenen Seite YouTube. Betreiber der Seiten ist die YouTube, LLC, 901 Cherry Ave., San Bruno, CA 94066, USA. Wenn du eine unserer mit einem YouTube-Plugin ausgestatteten Seiten besuchen, wird eine Verbindung zu den Servern von YouTube hergestellt. Dabei wird dem YouTube-Server mitgeteilt, welche unserer Seiten du besucht hast. Wenn du in deinem YouTube-Account eingeloggt bist, ermöglichst du YouTube, dein Surfverhalten direkt deinem persönlichen Profil zuzuordnen. Dies kannst du verhindern, indem du dich aus Ihrem YouTube-Account ausloggst.<br><br>Die Nutzung von YouTube erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.<br><br>Weitere Informationen zum Umgang mit Nutzerdaten findest du in der <a href="https://www.google.ch/intl/de/policies/privacy" target="_blank">Datenschutzerklärung von YouTube (Google)<a>.'
          },
          {
            title: "Adobe Fonts",
            content:
              'Wir setzen auf unserer Website Adobe Fonts zur visuellen Gestaltung ein. Adobe Fonts ist ein Dienst der Adobe Systems Incorporated, 345 Park Avenue, San Jose, CA 95110-2704, USA (Adobe), der uns den Zugriff auf eine Schriftartenbibliothek gewährt. Zur Einbindung der von uns benutzten Schriftarten, muss dein Browser eine Verbindung zu einem Server von Adobe in den USA aufbauen und die für unsere Website benötigte Schriftart herunterladen. Adobe erhält hierdurch die Information, dass von Ihrer IP-Adresse unsere Website aufgerufen wurde. Weitere Informationen zu Adobe Fonts, finden Sie in der Datenschutzerklärung von Adobe, welche du unter folgendem Link findest: <a href="https://www.adobe.com/ch_de/privacy/policies/adobe-fonts.html" target="_blank">Adobe Fonts Datenschutzerklärung</a>'
          }
        ]
      }
    ]
  }
});
